import { Link } from "react-router-dom";
import { Logo } from "@/components/bits";
import { DISCORD_URL } from "@/lib/images";
import { MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-black" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo size={48} />
          <p className="mt-6 max-w-sm text-sm text-white/50 leading-relaxed">
            Premium game enhancements engineered to stay undetected and undefeated.
            Trusted by players who refuse to lose.
          </p>
          <div className="mt-6 flex items-center gap-4 font-mono text-[11px] tracking-[0.2em] text-white/40">
            <span>UNDETECTED</span><span className="text-white/20">/</span>
            <span>UNDEFEATED</span><span className="text-white/20">/</span>
            <span>24/7 SUPPORT</span>
          </div>
        </div>

        <div>
          <h4 className="font-mono text-xs tracking-[0.25em] text-white/40 mb-5">// NAVIGATE</h4>
          <ul className="space-y-3 text-sm text-white/60">
            <li><Link to="/store" className="hover:text-white transition-colors">Store</Link></li>
            <li><Link to="/status" className="hover:text-white transition-colors">Status</Link></li>
            <li><Link to="/faq" className="hover:text-white transition-colors">FAQ</Link></li>
            <li><Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs tracking-[0.25em] text-white/40 mb-5">// SUPPORT</h4>
          <a href={DISCORD_URL} target="_blank" rel="noreferrer" data-testid="footer-discord-link"
             className="btn-inj px-5 py-3 text-xs inline-flex items-center gap-2">
            <MessageCircle size={14} /> JOIN DISCORD
          </a>
          <p className="mt-4 text-xs text-white/40 font-mono">discord.gg/injectd</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center">
        <p className="font-mono text-[11px] tracking-[0.2em] text-white/30">
          © {new Date().getFullYear()} GZ — ALL RIGHTS RESERVED. FOR EDUCATIONAL USE ONLY.
        </p>
      </div>
    </footer>
  );
}
